var exports = {
  "k": "xa15a2ab7--fefaab--container",
  "S": "xa15a2ab7--fefaab--muted",
};

module.exports = exports;
